import React from 'react';
import Select from 'react-select';
import { getTranslation } from '../../../../../utils/translation';

const Order = ({ orders, selectedOrder, onOpenBetsOrderChange }) => {
    const openBetsOrderOptions = [
        { label: getTranslation('ticketsFiltersOrdersDescending'), value: orders.descending },
        { label: getTranslation('ticketsFiltersOrdersAscending'), value: orders.ascending },
    ];

    const selectedOpenBetsOrderOption = openBetsOrderOptions.find(
        option => option.value === selectedOrder
    );

    return (
        <Select
            className='common-select common-select--filters'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedOpenBetsOrderOption}
            onChange={onOpenBetsOrderChange}
            options={openBetsOrderOptions}
        />
    );
};

export default Order;
